import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  return <section className="py-20 px-6 bg-[#14142B] text-[#F5F0E8] text-center" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold mb-12 text-white" data-id="element-212">
          Lo que vas a notar primero
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-8 mb-12" data-id="element-213">
          {["Menos 'una cosa más'", 'Menos tiempo total de cierre', 'Despertares más cortos y menos demandantes', 'Vos más estable (y eso cambia todo)'].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#1C1C2E] p-6 rounded-xl border border-[#D4A574]/10 flex items-center justify-center min-h-[100px]" data-id="element-214">
              <p className="text-lg font-medium text-[#F5F0E8]" data-id="element-215">{item}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-xl italic font-serif text-[#D4A574]" data-id="element-216">
          "No prometemos perfección. Prometemos un sistema que no dependa de tu
          fuerza de voluntad."
        </motion.p>
      </div>
    </section>;
}